export const getTeamDomain = (domain?: string) =>
  domain?.charAt(0) === '@' ? domain : `@${domain}`
